import { createContext, useContext } from "react";

import { type Provider } from "@stacklet/ui";

export const ProviderContext = createContext<Provider>("aws");

export const useProvider = () => {
  const result = useContext(ProviderContext);

  if (!result) {
    throw new Error("ProviderContext used outside of its Provider!");
  }

  return result;
};
